export default __webpack_public_path__ + "static/media/2269-01_closed.9bd80658.jpg";